import React from 'react';
import PropTypes from 'prop-types';

import { HeaderRow, BodyRow } from './TableComponents';

/**
 * Table-like component with predefined styling (see HeaderRow, BodyRow).
 *
 * @param {Array} headersCells - array of components
 * @param {Array} rows - array of arrays of components
 * @param {Bool}  striped - give gray background to every other row
 */
const Table = ({ headerCells, rows, widths, striped = false }) => {
  return (
    <>
      <HeaderRow cells={headerCells} widths={widths} />
      {rows.map((cellsInRow, index) => {
        const isGray = striped && index % 2 === 0;
        return <BodyRow key={index} cells={cellsInRow} widths={widths} gray={isGray} />;
      })}
    </>
  );
};

Table.propTypes = {
  headerCells: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  striped: PropTypes.bool,
  widths: PropTypes.array,
};

export default Table;
